class ElementQuickLinks {
  constructor() {
    document.querySelectorAll(".quick-links-block").forEach(block => {
      block.querySelectorAll(".qlb-toggle-label-text").forEach(showHideText => {
        showHideText.addEventListener("click", function() {
          this.closest(".quick-links-block")?.classList.toggle("expanded")
        })
      })
    })
  }
}

export default ElementQuickLinks
